import React from "react";
// import moment from "moment";
import PropTypes from "prop-types";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import Card from "../../../component/card/Card";
import { tableSkeleton } from "../../../constant/helper/helper";
import isEmpty from "../../../validation/isEmpty";
import {
  CREATED_AS_COLOR,
  CREATED_AS_STATUS
} from "../../../constant/constant";

const AttendanceList = ({
  values,
  userLoading,
  componentRef,
  userAttendanceData
}) => {
  const userAttendance = (attendanceData) => {
    if (userLoading) {
      return <tr>{tableSkeleton(9)}</tr>;
    } else if (isEmpty(attendanceData)) {
      return (
        <tr>
          <td>
            <span className="">No Data</span>
          </td>
        </tr>
      );
    } else if (!isEmpty(attendanceData.dailyPointsArray)) {
      return attendanceData.dailyPointsArray.map(
        (dailyAttendance, index) => (
          <tr style={{ fontSize: "12px" }} key={index}>
            <td>{index + 1}</td>
            <td className="text-center">{dailyAttendance.Date}</td>
            <td className="text-center">
              {dailyAttendance.locationName}
            </td>
            <td className="text-center">{dailyAttendance.inTime}</td>
            <td className="text-center">
              {dailyAttendance.inLocation}
            </td>
            <td className="text-center">{dailyAttendance.outTime}</td>
            <td className="text-center">
              {dailyAttendance.outLocation}
            </td>

            <td className="text-center">
              <span
                className={
                  CREATED_AS_COLOR[dailyAttendance.createdAs]
                }
              >
                {dailyAttendance.duration}
              </span>
            </td>
            <td className="text-center">
              <span
                className={
                  CREATED_AS_COLOR[dailyAttendance.createdAs]
                }
              >
                {CREATED_AS_STATUS[dailyAttendance.createdAs]}
              </span>
            </td>
          </tr>
        )
      );
    }
  };

  return (
    <Card>
      <div
        className="table-responsive"
        ref={componentRef}
        style={{
          height: "500px",
          overflow: "auto"
        }}
      >
        <table
          className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
          id="products-datatable"
        >
          <thead className="thead-light">
            <tr>
              <th style={{ width: "20px" }}>#</th>
              <th className="text-center">Date</th>
              <th className="text-center">Location</th>
              <th className="text-center">In-Time</th>
              <th className="text-center">In-Location</th>
              <th className="text-center">Out-Time</th>
              <th className="text-center">Out-Location</th>
              <th className="text-center">Hours</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>{userAttendance(userAttendanceData)}</tbody>
          <td></td>
          <tr>
            <th></th>
            {/* <th> Total Hours</th> */}
            <th>WO</th>
            <th>PL</th>
            <th>NBL</th>
            <th>PTL</th>
            <th>MTL</th>
            <th>BL</th>
            <th>CO</th>
            <th>OH</th>
          </tr>

          <tr>
            <td></td>
            {/* <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.total_duration
                : 0}
            </td> */}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalWeekOf
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalPl
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalNbl
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalPtl
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalMtl
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalBl
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalCo
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalOh
                : ""}
            </td>
          </tr>
          <tr>
            <th></th>
            <th>PH</th>
            <th>OD</th>
            <th>EO</th>
            <th>LC</th>
            <th>OT</th>
            <th>AML</th>
            <th>WOP</th>
            <th>HD</th>
          </tr>

          <tr>
            <td></td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalPh
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalOd
                : ""}
            </td>{" "}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalEo
                : ""}
            </td>{" "}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalLc
                : ""}
            </td>{" "}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalOT
                : ""}
            </td>{" "}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalAml
                : ""}
            </td>{" "}
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalWop
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.TotalHd
                : ""}
            </td>
          </tr>
          <tr>
            <th></th>
            <th>P</th>
            <th>Total</th>
            <th>Absent</th>
            <th>Name</th>
            <th>E-Id</th>
          </tr>
          <tr>
            <td></td>
            <td>{userAttendanceData.TotalPresent}</td>
            <td>
              {Math.round(userAttendanceData.TotalWeekOf) +
                Math.round(userAttendanceData.TotalWop) +
                Math.round(userAttendanceData.TotalOd) +
                Math.round(userAttendanceData.TotalLc) +
                Math.round(userAttendanceData.TotalEo) +
                Math.round(userAttendanceData.TotalPl) +
                Math.round(userAttendanceData.TotalNbl) +
                Math.round(userAttendanceData.TotalPtl) +
                Math.round(userAttendanceData.TotalMtl) +
                Math.round(userAttendanceData.TotalBl) +
                Math.round(userAttendanceData.TotalCo) +
                Math.round(userAttendanceData.TotalOh) +
                Math.round(userAttendanceData.TotalPh) +
                Math.round(userAttendanceData.TotalAml) +
                Math.round(userAttendanceData.TotalPresent) +
                Math.round(userAttendanceData.TotalOT) * 2 +
                Math.round(userAttendanceData.TotalHd) / 2}
            </td>
            <td> {userAttendanceData?.TotalAbsent || 0}</td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.workerFullName
                : ""}
            </td>
            <td>
              {!isEmpty(userAttendanceData)
                ? userAttendanceData.workerId
                : ""}
            </td>
          </tr>
        </table>
      </div>

      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export "
            table="products-datatable"
            className="btn btn-dark btn-block"
            filename={`${userAttendanceData?._id?.workerFullName}_${userAttendanceData?._id?.workerId}_${values.fromDate}_${values.toDate}`}
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Card>
  );
};

AttendanceList.propTypes = {
  userLoading: PropTypes.bool.isRequired,
  userAttendanceData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  componentRef: PropTypes.any.isRequired
};

export default AttendanceList;
